import styled from 'styled-components';

export const Container = styled.main`
  .judgement-decision {
    align-self: flex-end;
    text-align: -webkit-right;
  }
  .judgement-recap-sub-title {
    font-size: 13px;
    color: #8b8b8b;
    margin-bottom: 9px;
    margin-top: 30px;
  }
  .button {
    float: right;
    align-self: end;
  }
`;
